import { render, staticRenderFns } from "./DropdownListTraditionalGame.vue?vue&type=template&id=2cb6a7f2&scoped=true&"
import script from "./DropdownListTraditionalGame.vue?vue&type=script&lang=js&"
export * from "./DropdownListTraditionalGame.vue?vue&type=script&lang=js&"
import style0 from "./DropdownListTraditionalGame.vue?vue&type=style&index=0&id=2cb6a7f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb6a7f2",
  null
  
)

export default component.exports